<div class="h-screen w-screen flex justify-center items-center bg-white">
	<div class="text-center flex flex-col justify-center items-center">
		<h1 class="h1">
			Your Account Has Been <br />
			Temporarily Locked
		</h1>
		<p class="p-sm">
			Sorry for the inconvenience. To unlock your account,<br />
			Call <span class="font-semibold">1-888-520-4004</span> to speak with a
			member of our <br />
			Customer Success team.
		</p>
		<img
			src="assets/images/locked-account.svg"
			class="w-[320px] h-[207px] mt-20"
			alt="locked account"
		/>
	</div>
</div>
